import React, { useEffect, useState } from 'react';
import logoIcon from '../../assets/images/Jobs_Genius_Logo.png';
import SearchComponent from '../../components/SearchComponent/SearchComponent';
import SerpJobs from '../../components/SerpJobs/SerpJobs';
import './SerpPages.scss';
import useQueryHook from '../../customHooks/useQueryHook';

function SerpPage() {
    const { queryParams } = useQueryHook();

    const [jobDisplayArray, setJobDisplayArray] = useState([]);
    const [keyword, setKeyword] = useState(queryParams.get('keyword') || "");

    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const jobsPerPage = 20;

    const totalPages = Math.ceil(jobDisplayArray.length / jobsPerPage);
    const indexOfLastJob = currentPage * jobsPerPage;
    const indexOfFirstJob = indexOfLastJob - jobsPerPage;
    const currentJobs = jobDisplayArray.slice(indexOfFirstJob, indexOfLastJob);

    const generatePageNumbers = () => {
        const pages = [];
        for (let i = 1; i <= Math.min(totalPages, 6); i++) {
            pages.push(i);
        }
        return pages;
    };

    useEffect(() => {
        setCurrentPage(1);
    }, [jobDisplayArray]);
  
    return (
        <div className='serpPage-container'>
            <header className='navigation'>
                <img src={logoIcon} alt="JobGenius" className='logo-image' />
            </header>
            <main>
                <SearchComponent setJobDisplayArray={setJobDisplayArray} loading={loading} setLoading={setLoading} keyword={keyword} setKeyword={setKeyword}/>
                <div className='jobDisplay-container'>
                <div>
                {currentJobs.length === 0 ? (
                    <div style={{ display: 'flex', justifyContent: 'center', marginTop: '2rem' }}>
                        {loading? 'Loading...' : 'No results found'}
                    </div>
                ) : (
                    currentJobs.map((item, idx) => <SerpJobs item={item} key={idx} keyword={keyword} jobDisplayArray={jobDisplayArray}/>)
                )}
                </div>
            {totalPages > 1 && (
                <div className="pagination">
                    {generatePageNumbers().map((page, idx) => (
                        <button 
                            key={idx} 
                            // disabled={page === "..."} // Comment for sonar
                            disabled={typeof page !== 'number'}
                            onClick={() => {
                                if (typeof page === 'number') {
                                    setCurrentPage(page);
                                    window.scrollTo({ top: 0, behavior: 'smooth' }); // Scrolls to top smoothly
                                }
                            }}
                            className={currentPage === page ? 'active' : ''}
                        >
                            {page}
                        </button>
                    ))}
                </div>
            )}
                </div>
            </main>          
        </div>
    );
}

export default SerpPage;